import React, { Component } from'react';
import connect from "react-redux/es/connect/connect";
import { auth } from "../../../services/firebase/firebase";
import { getStatisticChats, getStatisticUsers } from "../../../services/firebase/chats";

import StatisticChat from './StatisticChat/StatisticChat';
import StatisticUsers from './StatisticUsers/StatisticUsers';

class Statistics extends Component {
  constructor(props){
    super(props);
    this.state = {
      statisticChat: {},
      statisticUsers: {},
      statisticUsersLoading: false,
    };

    auth().onAuthStateChanged(user => {
      if (user) {
        this.getStatisticsChatsAction();
        this.getStatisticsUsersAction();
      }

      this.setState({ user })
    });
  }

  getStatisticsChatsAction() {
    getStatisticChats()
      .then((statisticChat) => {
        statisticChat && this.setState({ statisticChat: statisticChat })
      })
      .catch((err) => console.error('Error Get Statistic Chats', err))
  }

  getStatisticsUsersAction() {
    this.setState({ statisticUsersLoading: true });

    getStatisticUsers()
      .then((statisticUsers) => {
        statisticUsers && this.setState({ statisticUsers: statisticUsers, statisticUsersLoading: false })
      })
      .catch((err) => console.error('Error Get Statistic Users', err))
  }

  render() {
    const { statisticChat, statisticUsers, statisticUsersLoading } = this.state;

    return (
      <div>
        <StatisticChat
          statisticChat={statisticChat}
        />

        {
          statisticUsersLoading ? (
            <span>loading...</span>
          ) : (
            <StatisticUsers
              statisticUsers={statisticUsers.usersStatistics || {}}
            />
          )
        }

      </div>
    )
  }
}

export default connect(
  (state) => {
    return { options: state.options };
  },
  { }
)(Statistics);



// WEBPACK FOOTER //
// ./src/components/Modules/Statistics/index.js